class DnaCardsBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.cards = block.querySelectorAll('.dna-card');
    this.overlay = block.querySelector('.dna-cards__overlay');
    this.swiperContainer = block.querySelector('.swiper-container');
    this.swiperWrapper = block.querySelector('.swiper-wrapper');
    this.swiper = null;

    this.cards.forEach((card, i) => {
      const slide = document.createElement('div');
      const cardClone = card.cloneNode();
      cardClone.innerHTML = card.innerHTML;
      cardClone.classList.add('dna-card--expanded');
      slide.classList.add('swiper-slide');
      slide.appendChild(cardClone);
      this.swiperWrapper.appendChild(slide);

      card.addEventListener('click', () => {
        if (!this.swiper) {
          this.init();
        }

        this.swiper.slideTo(i, 0);
        this.show();
      });
    });

    this.overlay.addEventListener('click', (e) => {
      if (
        e.target.classList.contains('dna-cards__overlay') ||
        e.target.classList.contains('swiper-container') ||
        e.target.classList.contains('swiper-wrapper') ||
        e.target.classList.contains('swiper-slide')
      ) {
        this.hide();
      }
    });

    window.addEventListener('keydown', (e) => {
      if (e.code === 'Escape') {
        this.hide();
      }
    });
  }

  init() {
    this.swiper = new Swiper(this.swiperContainer, {
      speed: 400,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 24,
      navigation: {
        nextEl: '.dna-cards__slider-nav-button--next',
        prevEl: '.dna-cards__slider-nav-button--prev',
        disabledClass: 'dna-cards__slider-nav-button--disabled',
      },
      keyboard: {
        enabled: true,
      },
      threshold: 3,
    });
  }

  show() {
    this.block.classList.add('dna-cards--overlay-visible');
    this.overlay.classList.add('dna-cards__overlay--visible');
  }

  hide() {
    this.block.classList.remove('dna-cards--overlay-visible');
    this.overlay.classList.remove('dna-cards__overlay--visible');
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.block .dna-cards').forEach((block) => {
  new DnaCardsBlock(block);
});

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview/type=dna-cards', ($block, attributes) => {
    new DnaCardsBlock($block.find('.dna-cards').get(0), attributes);
  });
}